"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/notebook/v1/admin_service.proto (package spwn.notebook.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminNotebookService = void 0;
const admin_service_pb_1 = require("./admin_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.notebook.v1.AdminNotebookService
 */
exports.AdminNotebookService = {
    typeName: "spwn.notebook.v1.AdminNotebookService",
    methods: {
        /**
         * 購入者情報抽出のジョブを実行する
         *
         * @generated from rpc spwn.notebook.v1.AdminNotebookService.ExecuteExportPurchasedOrdersJob
         */
        executeExportPurchasedOrdersJob: {
            name: "ExecuteExportPurchasedOrdersJob",
            I: admin_service_pb_1.AdminNotebookServiceExecuteExportPurchasedOrdersJobRequest,
            O: admin_service_pb_1.AdminNotebookServiceExecuteExportPurchasedOrdersJobResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * Logiに商品登録を実行する
         *
         * @generated from rpc spwn.notebook.v1.AdminNotebookService.RegisterLogi
         */
        registerLogi: {
            name: "RegisterLogi",
            I: admin_service_pb_1.AdminNotebookServiceRegisterLogiRequest,
            O: admin_service_pb_1.AdminNotebookServiceRegisterLogiResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 配信アンケートの設問情報を書き込む
         *
         * @generated from rpc spwn.notebook.v1.AdminNotebookService.CreateStreamingSurveys
         */
        createStreamingSurveys: {
            name: "CreateStreamingSurveys",
            I: admin_service_pb_1.AdminNotebookServiceCreateStreamingSurveysRequest,
            O: admin_service_pb_1.AdminNotebookServiceCreateStreamingSurveysResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * グッズ設定を行う際の確認用データを作成して返す
         *
         * @generated from rpc spwn.notebook.v1.AdminNotebookService.CreateGoodsDataForRegistration
         */
        createGoodsDataForRegistration: {
            name: "CreateGoodsDataForRegistration",
            I: admin_service_pb_1.AdminNotebookServiceCreateGoodsDataForRegistrationRequest,
            O: admin_service_pb_1.AdminNotebookServiceCreateGoodsDataForRegistrationResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * グッズ設定をFirestoreに保存する
         *
         * @generated from rpc spwn.notebook.v1.AdminNotebookService.RegisterGoodsData
         */
        registerGoodsData: {
            name: "RegisterGoodsData",
            I: admin_service_pb_1.AdminNotebookServiceRegisterGoodsDataRequest,
            O: admin_service_pb_1.AdminNotebookServiceRegisterGoodsDataResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * エンドポイント設定
         *
         * @generated from rpc spwn.notebook.v1.AdminNotebookService.ResetEndpoint
         */
        resetEndpoint: {
            name: "ResetEndpoint",
            I: admin_service_pb_1.AdminNotebookServiceResetEndpointRequest,
            O: admin_service_pb_1.AdminNotebookServiceResetEndpointResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * プレミア配信のスケジュール設定を行う
         *
         * @generated from rpc spwn.notebook.v1.AdminNotebookService.SetupPremierStreamingSchedule
         */
        setupPremierStreamingSchedule: {
            name: "SetupPremierStreamingSchedule",
            I: admin_service_pb_1.AdminNotebookServiceSetupPremierStreamingScheduleRequest,
            O: admin_service_pb_1.AdminNotebookServiceSetupPremierStreamingScheduleResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=admin_service_connect.js.map